import React, { useContext } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import CouponEvent from './CouponEvent';
import BetOptionsSection from './BetOptionsSection';
import { playableInMultiple } from '../../data/purchase-service';
import Bonus from './Bonus';
import BonusApplied from './BonusApplied';

export default function MultipleBets(props) {
    const betslipContext = useContext(BetslipContext);
	
	let betslipData = betslipContext.getBetslipData();
	const couponKey = props.couponKey;
    const coupon = betslipData.coupons[couponKey];
    const container = "multibets";
    const bonusDataMulti = coupon.multipleBonus;
    const showAdvise = coupon.selectedContainer === 'multibets' && bonusDataMulti != null && (betslipContext.toGetBonusAdvise?.showAdvise ?? false);
    
    let selections = coupon.selections;
    
    // restoring the selections array for the draw
    let restoredSelections = [];
    for (let k in selections) {
    	let selection = selections[k];
    	const playableInMulti = playableInMultiple(selection.bets);
    	if(betslipContext.isBetBuilder()){
    		// pushing it with all its bets: it will showed as a system
    		selection = JSON.parse(JSON.stringify(selection));
    		restoredSelections.push(selection);
    	}
    	else{
	    	if (selection.bets.length === 1) {
	    		// duplicate object
	    		selection = JSON.parse(JSON.stringify(selection));
	    		restoredSelections.push(selection);
	    	} 
	    	else {
	    		for (let km = 0; km < selection.bets.length; km++) {
	    			let bet = selection.bets[km];
	    			// km == 0; it is the first bet choosed: I've to render it in anycase
	    			// playableInMulti = true, it means that this draw can be rendered in multibets everytime, also if it is sharing
	    			// the pal.avv with another draw selected before.
	    			if(km == 0 || playableInMulti){
	    				let duplicatedSelection  = JSON.parse(JSON.stringify(selection));
	    				duplicatedSelection.bets = [];
	        			duplicatedSelection.bets.push(bet);
	        			restoredSelections.push(duplicatedSelection);			
	    			}
	    		}
	    	}
    	}
    }
    
    return (
        <>
            {betslipContext.betOptionsSectionMustBeShown() ? 
                <BetOptionsSection couponKey={couponKey} />
                :
                <>
                    {restoredSelections.map(function(selection) {
                        // always the first bet is taken: if an event had more than 1 bet, then I will face a duplicated event in the next selection
                        let betKey = `${selection.bets[0].scomSogei}_${selection.bets[0].handicap}-draw-${selection.bets[0].draw}`;
                        let reactKey = `key-bet-event-coupon-${couponKey}-container-${container}-pal-${selection.pal}-avv-${selection.avv}-for-bet-${betKey}`;
                        return (
                            <React.Fragment key={reactKey}>
                                <CouponEvent selection={selection} couponKey={couponKey} container={container} />
                            </React.Fragment>
                        )
                    })}
                </>
            }
            {showAdvise &&
                <>
                    <Bonus data={betslipContext.toGetBonusAdvise} desc={bonusDataMulti.description} />
                </>
            }
            {bonusDataMulti && bonusDataMulti.applied &&
                <BonusApplied appliedData={bonusDataMulti} bonusData={betslipContext.toGetBonusAdvise} />
            }
        </>
    );
}
